/**
 * This needs a refactor, it's a bit of a mess. :)
 */
import widgetFieldTypes from '../widgetFieldTypes';
import { FieldType } from '../widgetFieldTypes.const';

const isStringContained = (toFindIn = '', toFind = '') => {
	toFindIn = toFindIn.toLocaleLowerCase().replaceAll(' ', '');
	toFind = toFind.toLocaleLowerCase().replaceAll(' ', '');

	return toFindIn.includes(toFind);
};

/* Private */

const setupGroup = [FieldType.CredentialsSelector, FieldType.UserSchemaMappingsSelector];

const basicInputsGroup = [
	FieldType.ParagraphOutput,
	FieldType.TextInput,
	FieldType.RichTextInput,
	FieldType.EmailInput,
	FieldType.DatePicker,
	FieldType.DateTimePicker,
	FieldType.NumberInput,
	FieldType.Divider,
];

const tableGroup = [FieldType.Cards, FieldType.Table, FieldType.TableMapper];

const mediaGroup = [
	FieldType.ImageDisplay,
	FieldType.Gallery,
	FieldType.AudioInput,
	FieldType.FileInput,
	FieldType.Iframe,
	FieldType.VideoPlayer,
];
const tileMediaGroup = [FieldType.Gallery, FieldType.AudioInput, FieldType.FileInput];

const selectGroup = [FieldType.Dropdown, FieldType.CascadingDropdown, FieldType.Switch];

const connectedGroup = [FieldType.Search];

const miniAppsGroup = [
	FieldType.AIInput,
	FieldType.Loom,
	FieldType.ImageEditor,
	FieldType.Calendly,
	FieldType.Stripe,
	FieldType.HubSpotScheduler,
];

function getFieldsGroups(isTileEditor, isSlackTool) {
	let fieldGroups;
	if (isSlackTool) {
		fieldGroups = [
			{ separatorText: 'Basic inputs', fieldGroup: basicInputsGroup },
			{ separatorText: 'Tables', fieldGroup: [FieldType.Cards] },
			{ separatorText: 'Media', fieldGroup: [FieldType.FileInput, FieldType.ImageDisplay] },
			{ separatorText: 'Select', fieldGroup: [FieldType.Dropdown, FieldType.Switch] },
			{ separatorText: 'Connected blocks', fieldGroup: connectedGroup },
		];
	} else {
		fieldGroups = [
			{ separatorText: 'Setup blocks', fieldGroup: setupGroup },
			{ separatorText: 'Basic inputs', fieldGroup: basicInputsGroup },
			{ separatorText: 'Tables', fieldGroup: tableGroup },
			{ separatorText: 'Media', fieldGroup: isTileEditor ? tileMediaGroup : mediaGroup },
			{ separatorText: 'Select', fieldGroup: selectGroup },
			{ separatorText: 'Connected blocks', fieldGroup: connectedGroup },
			{ separatorText: 'Mini-apps', fieldGroup: miniAppsGroup, hidden: isTileEditor },
		];
	}
	return fieldGroups.filter((fg) => !fg.hidden);
}

function getEndRunFieldsGroups() {
	return [
		{ separatorText: 'Basic inputs', fieldGroup: [FieldType.ParagraphOutput] },
		{ separatorText: 'Tables', fieldGroup: tableGroup },
		{
			separatorText: 'Media',
			fieldGroup: [FieldType.ImageDisplay, FieldType.Gallery, FieldType.AudioInput, FieldType.Iframe, FieldType.VideoPlayer],
		},
		{ separatorText: 'Select', fieldGroup: [FieldType.EndRunButtons] },
	];
}

function filterWidgetFieldsGroups(filterFunc, isEndRunWidget, isTileEditor, isSlackTool) {
	return (isEndRunWidget ? getEndRunFieldsGroups() : getFieldsGroups(isTileEditor, isSlackTool))
		.map((fieldGroupObj) => {
			const newFieldGroup = fieldGroupObj.fieldGroup
				.map((fieldType) => {
					const field = { ...widgetFieldTypes[fieldType] };
					if (filterFunc(field)) {
						field.svgIcon = () => import('./assets/' + fieldType + '.svg');
						field.svgHoverIcon = () => import('./assets/' + fieldType + '-hover.svg');
						return field;
					}
					return null;
				})
				.filter((f) => !!f);
			return newFieldGroup.length > 0 ? { ...fieldGroupObj, fieldGroup: newFieldGroup } : undefined;
		})
		.filter((wfg) => !!wfg);
}

/* Public */

function getFieldGroups(
	searchString,
	isRichTextSupportOn,
	isAIMiniAppSupportOn,
	showConfigurationOnlyFields,
	isCascadeDropdownEnabled,
	isEndRunWidget,
	isTileEditor,
	isSlackTool
) {
	const CONDITIONAL_FIELDS = [
		{ condition: isRichTextSupportOn, type: FieldType.RichTextInput },
		{ condition: showConfigurationOnlyFields, type: FieldType.CredentialsSelector },
		{ condition: showConfigurationOnlyFields, type: FieldType.UserSchemaMappingsSelector },
		{ condition: isAIMiniAppSupportOn, type: FieldType.AIInput },
		{ condition: isCascadeDropdownEnabled, type: FieldType.CascadingDropdown },
	];

	const filterFunc = (field) => {
		if (!field.hidden && isStringContained(field.name, searchString)) {
			const conditionalField = CONDITIONAL_FIELDS.find((cf) => cf.type === field.type);
			if (conditionalField) {
				return conditionalField.condition;
			}
			return true;
		}
		return false;
	};
	return filterWidgetFieldsGroups(filterFunc, isEndRunWidget, isTileEditor, isSlackTool);
}

const WidgetSelectorModalService = {
	getFieldGroups,
};
export default WidgetSelectorModalService;
